module.exports = __webpack_public_path__ + "img/_lithuania.28d69881.png";